import {
  OrderDeliveryMethod,
  StatusLabel,
} from "../../../../common/constants/order-display.constants";
import { Paths, buildPath } from "../../../../common/paths/paths";
import { orderDeliveryMethodFor } from "../../../../services/orders/order-display.mapper";
import { Order, ORDER_SOURCE_IDS } from "../../../../services/orders/orders.types";

/** One orders page row in the website's own values (REQ-023); every order type maps onto it. */
export interface HardwareOrderRow {
  item?: string;
  order?: string;
  ordered?: string;
  deliveryMethod?: OrderDeliveryMethod;
  statusLabel?: StatusLabel;
  trackingPath?: string;
}

const trackingPathFor = (order: Order): string | undefined => {
  if (order.source === ORDER_SOURCE_IDS.ito) {
    return buildPath(Paths.amznhamOrderTracking.url, { orderId: order.orderId });
  }
  const serialNumber = order.replacedSerialNumber;
  if (order.source === ORDER_SOURCE_IDS.lcr && serialNumber) {
    return buildPath(Paths.lcrOrderTracking.url, { serialNumber });
  }
  return undefined;
};

export const toHardwareOrderRow = (order: Order): HardwareOrderRow => ({
  item: order.items?.[0]?.itemInformation?.name,
  order: order.orderReference,
  ordered: order.requested?.on,
  deliveryMethod: order.deliveryMethod && orderDeliveryMethodFor(order.deliveryMethod),
  statusLabel: order.statusLabel,
  trackingPath: trackingPathFor(order),
});
